import { ToastContainer } from "@olivahealth/oli-ui";
import React, { type ReactElement, Suspense, useEffect } from "react";
import {
  graphql,
  PreloadedQuery,
  usePreloadedQuery,
  useQueryLoader,
} from "react-relay";
import { useAmplitude } from "../../../services/contexts/AmplitudeContext";
import { useUserData } from "../../../services/contexts/UserDataContext";
import { CompanionContentLoader } from "./Loader";
import { CompanionContent } from "./CompanionContent";
import { HomePageQuery as IHomePageQuery } from "./__generated__/HomePageQuery.graphql";

const HomePageQuery = graphql`
  query HomePageQuery($userId: String!) {
    ...CompanionContent_data @arguments(userId: $userId)
  }
`;

function HomePageInner({
  queryRef,
}: {
  queryRef: PreloadedQuery<IHomePageQuery>;
}): ReactElement {
  const data = usePreloadedQuery(HomePageQuery, queryRef);

  return (
    <Suspense fallback={<CompanionContentLoader />}>
      <ToastContainer limit={1} />
      <CompanionContent data={data} />
    </Suspense>
  );
}

export default function HomePage(): ReactElement {
  const { trackEvent } = useAmplitude();
  const [queryRef, loadQuery] = useQueryLoader<IHomePageQuery>(HomePageQuery);
  const { data: user } = useUserData();

  useEffect(() => {
    trackEvent("Oli main page viewed");
  }, [trackEvent]);

  useEffect(() => {
    if (user?.id) {
      loadQuery({ userId: user.id }, { fetchPolicy: "network-only" });
    }
  }, [loadQuery, user?.id]);

  if (queryRef == null) {
    return (
      <div>
        <ToastContainer limit={1} />
        <CompanionContentLoader />
      </div>
    );
  }

  return (
    <Suspense fallback={<CompanionContentLoader />}>
      <HomePageInner queryRef={queryRef} />
    </Suspense>
  );
}
